import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/square-footage-calculator',
  component: () => import('../../routes/SquareFootageCalculator.svelte'),
  card: {
    id: 'square-footage-calculator',
    title: 'Square Footage Calculator',
    description:
      'Calculate square footage from length and width, estimate flooring or painting costs, and convert between sq ft and acres.',
    icon: 'square_foot',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/square-footage-calculator',
    category: 'Real Estate',
  },
  seo: {
    title: 'Square Footage Calculator – Calculate Area & Flooring Costs',
    description:
      'Free square footage calculator. Calculate area from length and width, estimate flooring and painting costs by price per sq ft, and convert sq ft to acres.',
  },
};

export default meta;